import { useEffect, useMemo, useRef } from "react";
import { createPureScopedStylesheet } from "..";
const usePureScopedStylesheet = (callback, settings, updateFromObject) => {
  const result = useMemo(() => createPureScopedStylesheet(callback, settings), []);
  const {
    updater
  } = result;
  if (updateFromObject && updater) {
    for (const k in updater) {
      const isFirstRun = useRef(true);
      useEffect(() => {
        var _updater$k;
        if (isFirstRun.current) {
          isFirstRun.current = false;
          return;
        }
        (_updater$k = updater[k]) === null || _updater$k === void 0 ? void 0 : _updater$k.call(updater, updateFromObject[k]);
      }, [updateFromObject[k]]);
    }
  }
  useEffect(() => {
    result.toggle(true);
    return () => !(settings !== null && settings !== void 0 && settings.reuse) && result.toggle(false);
  }, []);
  return result;
};
export { usePureScopedStylesheet };